export class DeleteUsers {
    constructor(userRepository) {
      this.userRepository = userRepository;
    }
  
    async execute(user) {
        debugger;
      return await this.userRepository.deleteUsers(user);
    }
  }